interface WhatsAppButtonProps {
  onClick?: () => void;
}

export default function WhatsAppButton({ onClick }: WhatsAppButtonProps) {
  const handleClick = () => {
    if (onClick) {
      onClick();
    }
  };

  return (
    <>
      <style>{`
        @keyframes float {
          0%, 100% {
            transform: translateY(0px);
          }
          50% {
            transform: translateY(-8px);
          }
        }
        
        @keyframes shimmer {
          0% {
            background-position: -200% center;
          }
          100% {
            background-position: 200% center;
          }
        }
        
        @keyframes glow {
          0%, 100% {
            box-shadow: 0 4px 20px rgba(34, 197, 94, 0.4), 0 0 40px rgba(34, 197, 94, 0.2);
          }
          50% {
            box-shadow: 0 4px 30px rgba(34, 197, 94, 0.6), 0 0 60px rgba(34, 197, 94, 0.3);
          }
        }
        
        .whatsapp-float {
          animation: float 3s ease-in-out infinite;
        }
        
        .whatsapp-glow {
          animation: glow 2s ease-in-out infinite;
        }
        
        .whatsapp-shimmer {
          background: linear-gradient(
            90deg,
            rgba(255, 255, 255, 0) 0%,
            rgba(255, 255, 255, 0.3) 50%,
            rgba(255, 255, 255, 0) 100%
          );
          background-size: 200% 100%;
          animation: shimmer 3s linear infinite;
        }
      `}</style>
      
      <button
        onClick={handleClick}
        className="fixed bottom-6 right-6 z-40 group whatsapp-float cursor-pointer"
      >
        <div className="relative flex items-center gap-3 bg-gradient-to-r from-green-500 to-green-600 hover:from-green-600 hover:to-green-700 text-white rounded-full px-4 py-4 sm:px-6 transition-all duration-500 hover:scale-110 whatsapp-glow overflow-hidden">
          {/* Shimmer effect overlay */}
          <div className="absolute inset-0 whatsapp-shimmer pointer-events-none"></div>
          
          {/* Content */}
          <div className="relative flex items-center gap-3 z-10">
            <i className="ri-whatsapp-line text-3xl transition-transform duration-300 group-hover:rotate-12"></i>
            <span className="hidden sm:inline font-semibold text-base whitespace-nowrap">Falar no WhatsApp</span>
          </div>
        </div>
      </button>
    </>
  );
}
